import { page } from './globalEvents';
import { myWalletClickHelper, sanitizeValue } from './helpers/index.js';

/**
 * @summary Sends GA Page event on Wallet Central
 */
export async function walletCentralPage(metadata, option) {
  page(metadata, option);
  return {};
}

/**
 * @summary Sends Pixall Click event on Sync Button Click
 */
export async function walletManualImportBtnClick(metadata, option) {
  if (option === void 0) {
    option = {};
  }
  const {
    useCDL = false
  } = option;
  const {
    data = {},
    dataLayer
  } = metadata;
  const {
    label = ''
  } = data;
  const eventResult = `cta::confirm-manual::import-settings${metadata?.data?.isNew ? '::first-use' : ''}`;
  const textContent = sanitizeValue(label);
  myWalletClickHelper({
    withPixallData: true,
    dataLayer,
    pixallLabel: 'cta::confirm-manual::import-settings',
    pixallData: {
      cdl: useCDL ? {
        eventProperties: {
          event: {
            element: 'Sync with ID Button',
            action: 'Click',
            intention: 'Sync Your Shopping Complete',
            location: 'Sync Your Shopping Modal',
            elementText: textContent
          }
        }
      } : undefined
    }
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends PixAll Click event on Import settings link click
 */
export async function walletImportSettingsClick(metadata, option) {
  const eventResult = 'text-link::import-settings';
  const {
    dataLayer = {}
  } = metadata;
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends Pixall Click event on automatic sync
 */
export async function walletAutoSyncSuccess(metadata, option) {
  const {
    dataLayer = {}
  } = metadata;
  const eventResult = 'text-link::automatic::import-settings';
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends Pixall Click event on Email Sync click
 */
export async function walletEmailSyncBtnClick(metadata, option) {
  if (option === void 0) {
    option = {};
  }
  const {
    useCDL = false
  } = option;
  const {
    data = {},
    dataLayer
  } = metadata;
  const {
    label = ''
  } = data;
  const textContent = sanitizeValue(label);
  const eventResult = 'cta::sync-now_email::my-wallet';
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult,
    pixallData: {
      cdl: useCDL ? {
        eventProperties: {
          event: {
            element: 'Use My Email Button',
            action: 'Click',
            intention: 'Sync Your Shopping Complete',
            location: 'Sync Your Shopping Modal',
            elementText: textContent
          }
        }
      } : undefined
    }
  }, option);
  return {
    eventResult
  };
}

/**
 * @summary Sends Pixall Click event on footer click
 */
export async function walletIdSyncFooterClick(metadata, option) {
  const {
    dataLayer = {}
  } = metadata;
  const eventResult = 'text-link::where-is-my-wallet-id';
  myWalletClickHelper({
    dataLayer,
    withPixallData: true,
    pixallLabel: eventResult
  }, option);
  return {
    eventResult
  };
}
export default {
  walletCentralPage,
  walletManualImportBtnClick,
  walletImportSettingsClick,
  walletAutoSyncSuccess,
  walletEmailSyncBtnClick,
  walletIdSyncFooterClick
};